import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';

// Register required Chart.js components
Chart.defaults.global = Chart.defaults.global || {};
Chart.defaults.global.elements = Chart.defaults.global.elements || {};
Chart.defaults.global.elements.line = Chart.defaults.global.elements.line || {};
Chart.defaults.global.elements.line.tension = 0.1;

const SalesAmountChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    // Clean up any existing chart
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (!data || data.length === 0 || !chartRef.current) {
      return;
    }

    // Sort data by date
    const sortedData = [...data].sort((a, b) => 
      new Date(a.date) - new Date(b.date)
    );

    // Extract dates and sales amounts
    const dates = sortedData.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
    });
    const inrSalesAmount = sortedData.map(item => item.total_inr_sales_amount);
    const usdSalesAmount = sortedData.map(item => item.total_usd_sales_amount);


    console.log(usdSalesAmount)
    // Create the chart
    const ctx = chartRef.current.getContext('2d');
    
    // Create chart configuration
    const config = {
      type: 'bar',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'INR Sales',
            data: inrSalesAmount,
            backgroundColor: 'rgba(75, 192, 192, 0.5)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          },
          {
            label: 'USD Sales',
            data: usdSalesAmount,
            backgroundColor: 'rgba(153, 102, 255, 0.5)',
            borderColor: 'rgba(153, 102, 255, 1)',
            borderWidth: 1
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Sales Analysis'
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              
              if (data.datasets[tooltipItem.datasetIndex].label === 'INR Sales') {
                label += '₹' + tooltipItem.yLabel.toFixed(2);
              } else if (data.datasets[tooltipItem.datasetIndex].label === 'USD Sales') {
                label += '$' + tooltipItem.yLabel.toFixed(2);
              }
              
              return label;
            }
          }
        },
        legend: {
          position: 'bottom'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Amount'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }]
        }
      }
    };
    
    // Create the chart
    chartInstance.current = new Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ height: '300px', position: 'relative' }}>
      {data && data.length > 0 ? (
        <canvas ref={chartRef} />
      ) : (
        <div className="text-center pt-5">No data available for the selected period</div>
      )}
    </div>
  );
};

export default SalesAmountChart;